import React from 'react'
import { Pane, Text } from 'evergreen-ui'
import { useStatusContent } from '../../../config/roundContent'

const StatusRegister_5 = ({ DataRegister }) => {
  const row = DataRegister?.[0] || {}
  const { statusContent } = useStatusContent(row.ROB_ID, "5")
  const title = statusContent.titleText || 'สละสิทธิ์เข้าศึกษา'

  return (
    <Pane
      color="#fff"
      backgroundColor="#b30000ff"
      height="100%"
      paddingY={4}
      paddingX={5}
      fontSize={14}
      fontFamily=""
      margin={0}
      fontWeight={700}
      justifyContent="center"
      alignItems="center"
      display="flex"
      flexDirection="column"
    >
      {title}
      {statusContent.bodyText ? (
        <Text color="#fff" fontSize={12} marginTop={4}>{statusContent.bodyText}</Text>
      ) : null}
    </Pane>
  )
}

export default StatusRegister_5
